import React from "react";
import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";

import moment from "moment";

export default function UserProfileChangeEmailHistoryModal(props) {
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent>
				<div>
					<div className="p-2 modals-headers-bar">
						<span>All Data</span>
						<button
							type="button"
							className="close"
							aria-label="Close"
							onClick={props.toggleModal}
						>
							<X
								style={{ pointerEvents: "none" }}
								color="white"
							/>
						</button>
					</div>
					<div
						className="modal-body"
						style={{ overflowY: "scroll", height: "400px" }}
					>
						<span>
							<b>All Data</b>
						</span>
						<div>
							<span>
								<pre>
									{JSON.stringify(props.allData, null, 2)}
								</pre>
							</span>
						</div>
					</div>
				</div>
			</ModalContent>
		</Modal>
	);
}
